import logo from './logo.svg';
import './App.css';
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCwdzkhI2Dn57nZ0uoVXcGqSRGdjwMWakQ",
  authDomain: "pick-em-8d655.firebaseapp.com",
  projectId: "pick-em-8d655",
  storageBucket: "pick-em-8d655.firebasestorage.app",
  messagingSenderId: "322765838240",
  appId: "1:322765838240:web:9aeed1c10b0e99d11076c5"
};

const app = initializeApp(firebaseConfig);

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
